import type { HTMLAttributes, ReactNode } from "react";
import { Card as UiCard } from "./ui/card";
import { cn } from "./cn";

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <UiCard className={cn("block gap-0 rounded-lg py-0 shadow-none", className)} {...props} />;
}
export interface CardHeaderProps extends HTMLAttributes<HTMLDivElement> {
  title?: string;
  description?: string;
  action?: ReactNode;
}
export function CardHeader({ title, description, action, className, children, ...props }: CardHeaderProps) {
  return (
    <div className={cn("flex flex-col gap-3 border-b px-5 py-4 sm:flex-row sm:items-start sm:justify-between", className)} {...props}>
      <div className="min-w-0">
        {title && <h2 className="text-sm font-semibold text-foreground">{title}</h2>}
        {description && <p className="mt-1 text-xs leading-5 text-muted-foreground">{description}</p>}
        {children}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
export function CardContent({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("p-5", className)} {...props} />;
}
export function CardFooter({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("flex items-center justify-end gap-3 border-t px-5 py-4", className)} {...props} />;
}
